'use client';

import { Laboratory } from '@medprev-web-app/api-graphql-client';
import { ReactNode } from 'react';

import { BranchLaboratoryAboutSection } from './branch-laboratory-about-section.component';

import { EntitySectionDivider } from '@/app/(main)/(pages)/_components/entities/entity-section-divider.component';
import {
  EntityTab,
  EntityTabContent,
  EntityTabList,
  EntityTabProvider,
  EntityTabTrigger,
} from '@/app/(main)/(pages)/_components/entities/entity-tab.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface TabLaboratoryProps {
  laboratory: Laboratory;
  rating: ReactNode;
}

export function TabLaboratory({
  laboratory,
  rating,
}: TabLaboratoryProps) {
  return (
    <EntityTabProvider>
      <EntityTab defaultValue="about" tabs={['about', 'rating', 'exams']}>
        <EntityTabList className="sticky top-0 bg-white pt-2 pb-4">
          <EntityTabTrigger
            value="about"
            data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_TAB_ABOUT}
          >
            Sobre
          </EntityTabTrigger>
          <EntityTabTrigger
            value="rating"
            data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_TAB_REVIEWS}
          >
            Avaliações
          </EntityTabTrigger>
        </EntityTabList>

        <div>
          <EntityTabContent value="about">
            <BranchLaboratoryAboutSection laboratory={laboratory} />
          </EntityTabContent>

          <EntityTabContent value="rating">
            <EntitySectionDivider />
            {rating}
          </EntityTabContent>
        </div>
      </EntityTab>
    </EntityTabProvider>
  );
}
